import { Flex } from "antd";
import { MICROGRID_SITE_IDS } from "../configs/configs";
import {
  AppstoreOutlined,
  DesktopOutlined,
  PieChartOutlined,
  DashboardOutlined,
  LineChartOutlined,
  AlertOutlined,
  ReconciliationOutlined,
  UnorderedListOutlined,
  RobotOutlined,
} from "@ant-design/icons";

const header_height = 58;

export default function useNavMenu({
  authenticationState,
  subscribePpaBilling,
  subscribeCarbonManagement,
  subscribeAiPvDiagnosis,
  subscribeAiBess,
  siteSelected,
}) {
  const NavMenu = [
    authenticationState.user_type < 3 // only superuser and admin will be able to see site list
      ? {
          label: (
            <Flex
              align="center"
              justify="start"
              style={{ paddingInline: 4, height: header_height }}
            >
              <UnorderedListOutlined style={{ marginRight: 8 }} />
              Site List
            </Flex>
          ),
          key: "SiteList",
        }
      : null,
    {
      label: (
        <Flex
          align="center"
          justify="start"
          style={{ paddingInline: 4, height: header_height }}
        >
          <DashboardOutlined style={{ marginRight: 8 }} />
          Dashboard
        </Flex>
      ),
      key: "Dashboard",
    },
    {
      label: (
        <Flex
          align="center"
          justify="start"
          style={{ paddingInline: 4, height: header_height }}
        >
          <LineChartOutlined style={{ marginRight: 8 }} />
          Analytics
        </Flex>
      ),
      key: "Analytics",
      children: [
        authenticationState.username === "Openre_superior"
          ? {
              label: "Power Demand and Forecast",
              key: "PowerDemandAndForecast",
            }
          : null,
        {
          label: "Power Demand",
          key: "PowerDemand",
        },
        {
          label: "Energy Demand",
          key: "EnergyDemand",
        },
        {
          label: "Parameter",
          key: "Parameter",
        },
        authenticationState.user_type === 1
          ? {
              label: "Data Health",
              key: "DataHealth",
            }
          : null,
      ],
    },
    {
      label: (
        <Flex
          align="center"
          justify="start"
          style={{ paddingInline: 4, height: header_height }}
        >
          <DesktopOutlined style={{ marginRight: 8 }} />
          System
        </Flex>
      ),
      key: "System",
    },
    {
      label: (
        <Flex
          align="center"
          justify="start"
          style={{ paddingInline: 4, height: header_height }}
        >
          <AlertOutlined style={{ marginRight: 8 }} />
          Alarm
        </Flex>
      ),
      key: "Alarms",
      children: [
        {
          label: "Alarm Record",
          key: "AlarmRecord",
        },
        authenticationState.user_type === 1
          ? {
              label: "Alarm Trending",
              key: "AlarmTrending",
            }
          : null,
        authenticationState.user_type === 1
          ? {
              label: "Service Alarm Record",
              key: "ServiceAlarmRecord",
            }
          : null,
      ],
    },
    {
      label: (
        <Flex
          align="center"
          justify="start"
          style={{ paddingInline: 4, height: header_height }}
        >
          <ReconciliationOutlined style={{ marginRight: 8 }} />
          Reports
        </Flex>
      ),
      key: "Reports",
      children: [
        authenticationState.username !== "kawan"
          ? {
              label: "System Report",
              key: "SystemReport",
            }
          : null,
        subscribePpaBilling
          ? {
              label: "ST Report",
              key: "STReport",
            }
          : null,
        subscribeAiBess && !MICROGRID_SITE_IDS.includes(siteSelected)
          ? {
              label: "Saving Report",
              key: "SavingReport",
            }
          : null,
        subscribeAiBess && MICROGRID_SITE_IDS.includes(siteSelected)
          ? {
              label: "Saving Report",
              key: "SavingReportMicrogrid",
            }
          : null,
      ],
    },
    authenticationState.username == "ajm"
      ? {
          label: (
            <Flex
              align="center"
              justify="start"
              style={{ paddingInline: 4, height: header_height }}
            >
              <RobotOutlined style={{ marginRight: 8 }} />
              Chatbot
            </Flex>
          ),
          key: "Chatbot",
        }
      : null,
    authenticationState.user_type < 3 // only superuser and admin will be able to see site list
      ? {
          label: (
            <Flex
              align="center"
              justify="start"
              style={{ paddingInline: 4, height: header_height }}
            >
              <PieChartOutlined style={{ marginRight: 8 }} />
              Management
            </Flex>
          ),
          key: "Management",
          children: [
            // {
            //   label: "Maintenance",
            //   key: "Maintenance",
            // },
            {
              label: "Configuration",
              key: "Configuration",
            },
          ],
        }
      : null,
    subscribePpaBilling ||
    subscribeCarbonManagement ||
    subscribeAiPvDiagnosis ||
    (subscribeAiBess && authenticationState.user_type === 1)
      ? {
          label: (
            <Flex
              align="center"
              justify="start"
              style={{
                paddingInline: 4,
                height: header_height,
              }}
            >
              <AppstoreOutlined style={{ marginRight: 8 }} />
              Features
            </Flex>
          ),
          key: "Features",
          children: [
            subscribePpaBilling
              ? {
                  label: "PPA Billing",
                  key: "PPABilling",
                }
              : null,
            subscribeCarbonManagement
              ? {
                  label: "Carbon Management",
                  key: "CarbonManagement",
                }
              : null,
            subscribeAiPvDiagnosis
              ? {
                  label: "AI-PV Diagnosis",
                  key: "AIPVDiagnosis",
                }
              : null,
            subscribeAiBess && authenticationState.user_type === 1
              ? {
                  label: "AIE-DR",
                  key: "AIEDR",
                }
              : null,
          ],
        }
      : null,
  ];

  return [NavMenu, header_height];
}
